import RepetitionInterval from '@/domain/termine/components/RepetitionInterval/RepetitionInterval';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';
import { RepetitionIntervalDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/RepetitionIntervalDrawer';
import { Field, FieldLabel } from '@e2n/ui';

export function RepetitionIntervalFormField() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <div className="flex flex-col gap-4 w-full">
      <form.Field name="wiederholung">
        {(field) => (
          <Field className="flex flex-col w-full gap-1">
            <FieldLabel>{t('domain.termine.repeat')}</FieldLabel>
            <div className="block md:hidden">
              <RepetitionIntervalDrawer
                value={field.state.value ?? TerminWiederholung.OHNE}
                onChange={field.handleChange}
              />
            </div>
            <div className="hidden md:block">
              <RepetitionInterval
                value={field.state.value ?? TerminWiederholung.OHNE}
                onChange={field.handleChange}
              />
            </div>
          </Field>
        )}
      </form.Field>
      <form.Subscribe selector={(state) => state.values.wiederholung}>
        {(wiederholung) =>
          wiederholung !== TerminWiederholung.OHNE ? (
            <DatePickerFormField name="wiederholungBis" />
          ) : null
        }
      </form.Subscribe>
    </div>
  );
}
